<template>
  <div>
    <v-dialog v-model="isOpen" width="600" persistent>
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between">
          <h1>{{ dialogTitle }}</h1>
          <v-btn icon @click="close()" class="align-self-end">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="isNegociationLoading" class="d-flex justify-center py-12">
            <v-progress-circular color="primary" indeterminate class="py-12" />
          </div>
          <v-form ref="weightTariffForm" v-else :key="forceReset">
            <v-row class="my-1">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="weight"
                  v-mask="'##################'"
                  label="Peso (Obrigatório)"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="!isPercentage">
                <v-text-field v-model="value" v-money="money" label="Valor"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="isPercentage">
                <v-text-field
                  ref="percentageField"
                  label="Porcentagem (Obrigatório)"
                  v-model="percentage"
                  v-money="moneyPercentage"
                  type="text"
                  :rules="[rules.hasPercentage]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="isPercentage">
                <v-text-field v-model="valueMin" v-money="money" label="Valor Mínimo"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-4">
          <v-btn @click="close()" color="error" class="flex-grow-1"> CANCELAR </v-btn>
          <v-btn
            @click="onSubmitConfirm()"
            :loading="isButtonLoading"
            :disabled="shouldDisableEditButton"
            color="success"
            class="flex-grow-1"
          >
            SALVAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError :errors="errors" @closeMessages="errors = []" :type="errorsType" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { VMoney } from 'v-money';
import MessagesError from '@/components/MessagesError.vue';
// import removeCaracters from '@/utils/removeCaracters';
import removePriceMask from '@/utils/removePriceMask';
import removePercentageMask from '@/utils/removePercentageMask';
import { stringToMoneyMask } from '@/handlers/MoneyHandler';
import maskCNPJ from '@/utils/maskCNPJ';
export default {
  components: {
    MessagesError
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },

    negociationWeightIdToEdit: {
      type: String,
      default: null
    },

    negociation: {
      type: Object,
      default: null
    }
  },

  directives: { money: VMoney },

  data: () => ({
    isButtonLoading: false,
    isNegociationLoading: false,
    forceReset: 0,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    },
    moneyPercentage: {
      decimal: '.',
      thousands: '',
      prefix: '',
      suffix: '%',
      precision: 2,
      masked: false
    },
    valueMin: null,
    percentage: null,
    errors: [],
    errorsType: 'error',
    weight: null,
    value: null,
    loadingToCreate: false,
    rules: {
      required: (value) => !!value || 'Campo obrigatório!',
      hasPercentage: (value) => {
        return (value !== null && value !== '0.00%') || 'Campo obrigatório!';
      }
    }
  }),

  computed: {
    ...mapGetters('AdressStore', ['getStates', 'getCities']),
    isCnpjNegociation() {
      return this.negociation ? !!this.negociation['cpfOrCnpj'] : false;
    },
    isEdit() {
      return this.negociationWeightIdToEdit !== null;
    },
    cityOrCnpj() {
      if (this.negociation) {
        const nameOrCpnj = this.isCnpjNegociation ? maskCNPJ(this.negociation['cpfOrCnpj']) : this.negociation['name'];
        return nameOrCpnj;
      }
      return null;
    },
    dialogTitle() {
      return `${this.isEdit ? 'Editar' : 'Nova'} tarifa por peso - ${this.cityOrCnpj}`;
    },
    isPercentage() {
      return this.negociation ? this.negociation.isPercentage : false;
    },
    shouldDisableEditButton() {
      return (
        !this.weight || this.weight == 0 || (this.transformPercentageToSend(this.percentage) === 0 && this.isPercentage)
      );
    }
  },

  watch: {
    isOpen: {
      handler(isOpen) {
        if (isOpen && this.isEdit) {
          this.fetchMyNegotiationByID();
        } else {
          this.resetNegociation();
        }
      }
    }
  },

  mounted() {
    if (this.typeRoute) {
      this.type = Number(this.typeRoute);

      this.fetchMyNegotiationByID();
    } else {
      this.isNegociationLoading = false;
    }
  },

  methods: {
    ...mapActions('TranshipmentStore', [
      'createNegotiationWeight',
      'fetchNegotiationWeigthByID',
      'editNegotiationWeigthByID'
    ]),

    onSubmitConfirm() {
      return this.isEdit ? this.editNegociation() : this.createNegociation();
    },

    async createNegociation() {
      this.isButtonLoading = true;

      const negociationType = {
        city: { key: 'negotiationCityId', value: this.negociation.id },
        cnpj: { key: 'negotiationCpfOrCnpjId', value: this.negociation.id }
      };

      const { key, value, isCnpj } = negociationType[this.isCnpjNegociation ? 'cnpj' : 'city'];

      let params = {
        price: !this.isPercentage ? Number(removePriceMask(this.value)) : null,
        percentage: this.isPercentage ? Number(removePercentageMask(this.percentage)) : null,
        minimumValue: this.isPercentage ? Number(removePriceMask(this.valueMin)) : null,
        upToWeight: Number(this.weight),
        [key]: value,
        isCnpj
      };

      try {
        const status = await this.createNegotiationWeight(params);

        if (status.success) {
          this.errorsType = 'success';
          this.errors = ['Tarifa de peso criada com sucesso!'];
          this.$emit('shouldRefresh');
          this.close();
        } else {
          this.errorsType = 'error';
          this.errors = status.errors;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isButtonLoading = false;
      }
    },

    async editNegociation() {
      this.isButtonLoading = true;

      const negociationType = {
        city: { key: 'negotiationCityId', value: this.negociation.id },
        cnpj: { key: 'negotiationCpfOrCnpjId', value: this.negociation.id }
      };

      const { key, value } = negociationType[this.isCnpjNegociation ? 'cnpj' : 'city'];
      const { isCnpj } = this.negociation;

      let params = {
        id: this.negociationWeightIdToEdit,
        price: !this.isPercentage ? Number(removePriceMask(this.value)) : null,
        percentage: this.isPercentage ? Number(removePercentageMask(this.percentage)) : null,
        minimumValue: this.isPercentage ? Number(removePriceMask(this.valueMin)) : null,
        upToWeight: Number(this.weight),
        [key]: value,
        isCnpj
      };

      try {
        const status = await this.editNegotiationWeigthByID(params);
        if (status.success) {
          this.errorsType = 'success';
          this.errors = ['Tarifa editada com sucesso!'];
          this.$emit('shouldRefresh');
          this.close();
        } else {
          this.errorsType = 'error';
          this.errors = status.errors;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isButtonLoading = false;
      }
    },

    async fetchMyNegotiationByID() {
      this.isNegociationLoading = true;

      const { isCnpj } = this.negociation;
      const id = this.negociationWeightIdToEdit;
      const params = {
        isCnpj,
        id
      };

      try {
        if (isCnpj) {
          const data = await this.fetchNegotiationWeigthByID(params);
          const { price, upToWeight, percentage, minimumValue } = data;
          this.value = stringToMoneyMask(price);
          this.percentage = percentage ? stringToMoneyMask(percentage) : '0.00%';
          this.valueMin = stringToMoneyMask(minimumValue);
          this.weight = upToWeight;
        } else {
          const data = await this.fetchNegotiationWeigthByID(params);
          const { price, upToWeight, percentage, minimumValue } = data;
          this.value = stringToMoneyMask(price);
          this.percentage = percentage ? stringToMoneyMask(percentage) : '0.00%';
          this.valueMin = stringToMoneyMask(minimumValue);
          this.weight = upToWeight;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isNegociationLoading = false;
      }
    },

    resetNegociation() {
      setTimeout(() => {
        this.$refs.weightTariffForm.reset();
        this.weight = null;
        this.value = null;
        this.percentage = '0.00%';
        this.valueMin = null;
        this.forceReset = this.forceReset + 1;
      }, 100);
    },

    transformPercentageToSend(element) {
      if (!element) return null;
      var percentage = element.toString().trim();
      percentage = percentage.replace('%', '').replace(',', '.');
      return Number(percentage);
    },

    close() {
      this.$emit('update:isOpen', false);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__slot {
  margin: 0;
  padding: 0;

  &::after,
  &::before {
    display: none !important;
  }
}
::v-deep.v-input {
  .v-text-field {
    &__details {
      padding-top: 0x;
      display: inline-block;
    }
  }
}
.v-dialog > .v-card > .v-card__text {
  padding: 0 24px 0px;
}
</style>
